

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SellerView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminSellers } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type UpdateSellerInput = {
  sellerId: string;
  name?: string;
  email?: string;
  phone?: string;
};

export function useUpdateSellerMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ sellerId, ...body }: UpdateSellerInput) =>
      apiJsonClient<SellerView>(endpoints.admin.sellerById(sellerId), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
    onSuccess: async (_data, variables) => {
      await invalidateAdminSellers(queryClient);
      await queryClient.invalidateQueries({
        queryKey: queryKeys.admin.sellerById(variables.sellerId),
        exact: true,
      });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
